import React, { useEffect } from 'react';
import SellerRoutes from './routes/SellerRoutes';
import './styles/global.css';

export default function App() {
  // Enforce scroll at DOM level — runs on every mount/unmount
  // This overrides any CSS rule that may lock height or overflow on html/body
  useEffect(() => {
    const enforce = () => {
      const html = document.documentElement;
      const body = document.body;
      const root = document.getElementById('root');

      [html, body].forEach(el => {
        if (el) {
          el.style.setProperty('overflow-y', 'auto', 'important');
          el.style.setProperty('overflow-x', 'hidden', 'important');
          el.style.setProperty('height', 'auto', 'important');
          el.style.setProperty('touch-action', 'auto', 'important');
        }
      });

      if (root) {
        root.style.setProperty('overflow', 'visible', 'important');
        root.style.setProperty('height', 'auto', 'important');
      }
    };

    enforce();
    // Re-enforce on resize to catch breakpoint transitions
    window.addEventListener('resize', enforce);
    return () => window.removeEventListener('resize', enforce);
  }, []);

  return (
    <div className="haatza-seller-root">
      <SellerRoutes />
    </div>
  );
}
